import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../api/auth';

interface User {
  id: number; company_id: number; branch_id: number | null;
  role_id: number; name: string; email: string; scope: string; is_active: boolean;
  is_super_admin?: boolean; permissions?: string[];
}
interface AuthContextType {
  user: User | null; token: string | null; companyId: number | null; branchId: number | null;
  login: (token: string, user: User, companyId: number, branchId: number | null) => void;
  logout: () => void; isAuthenticated: boolean; hasPermission: (code: string) => boolean;
  isSuperAdmin: boolean;
}
const AuthContext = createContext<AuthContextType | null>(null);
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(() => { try { const u = localStorage.getItem('user'); return u ? JSON.parse(u) : null; } catch { return null; } });
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('token'));
  const [companyId, setCompanyId] = useState<number | null>(() => { const c = localStorage.getItem('company_id'); return c ? Number(c) : null; });
  const [branchId, setBranchId] = useState<number | null>(() => { const b = localStorage.getItem('branch_id'); return b ? Number(b) : null; });
  const login = (token: string, user: User, companyId: number, branchId: number | null) => {
    localStorage.setItem('token', token); localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('company_id', String(companyId)); localStorage.setItem('branch_id', String(branchId ?? ''));
    setToken(token); setUser(user); setCompanyId(companyId); setBranchId(branchId);
  };
  const logout = async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('token'); localStorage.removeItem('user');
    localStorage.removeItem('company_id'); localStorage.removeItem('branch_id');
    setToken(null); setUser(null); setCompanyId(null); setBranchId(null);
    window.location.href = '/login';
  };
  const hasPermission = (code: string) => Array.isArray(user?.permissions) ? user!.permissions!.includes(code) : false;
  const isSuperAdmin = !!user?.is_super_admin;
  return <AuthContext.Provider value={{ user, token, companyId, branchId, login, logout, isAuthenticated: !!token, hasPermission, isSuperAdmin }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
